module.exports = __webpack_public_path__ + "static/7-creencias-df85f8770bb8648d370b465dc14ae250.jpg";